import './calendar.scss';
import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { CnCalendar as UICnCalendar } from './calendar';
const CnCalendar = withI18n(UICnCalendar, {
    locale,
    _noHoc: true,
});
export { CnCalendar };
